import DropdownButton from './src/main'

DropdownButton.install = function(Vue) {
  Vue.component(DropdownButton.name, DropdownButton);
};

export default DropdownButton;